module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiCn.e1c70da.ttf";